import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import cmsContentBlocksService from "./cmsContentBlocksService";

export const getContentBlocks = createAsyncThunk(
  "cmsContentBlocks/get-content-blocks",
  async (params, thunkAPI) => {
    try {
      return await cmsContentBlocksService.getContentBlocks(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createContentBlock = createAsyncThunk(
  "cmsContentBlocks/create-content-block",
  async (blockData, thunkAPI) => {
    try {
      return await cmsContentBlocksService.createContentBlock(blockData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAContentBlock = createAsyncThunk(
  "cmsContentBlocks/get-a-content-block",
  async (id, thunkAPI) => {
    try {
      return await cmsContentBlocksService.getContentBlock(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateAContentBlock = createAsyncThunk(
  "cmsContentBlocks/update-content-block",
  async ({ id, blockData }, thunkAPI) => {
    try {
      return await cmsContentBlocksService.updateContentBlock(id, blockData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAContentBlock = createAsyncThunk(
  "cmsContentBlocks/delete-content-block",
  async (id, thunkAPI) => {
    try {
      return await cmsContentBlocksService.deleteContentBlock(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  contentBlocks: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const cmsContentBlocksSlice = createSlice({
  name: "cmsContentBlocks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContentBlocks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getContentBlocks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.contentBlocks = action.payload;
      })
      .addCase(getContentBlocks.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createContentBlock.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createContentBlock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdContentBlock = action.payload;
      })
      .addCase(createContentBlock.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAContentBlock.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAContentBlock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.blockName = action.payload.name;
        state.blockType = action.payload.type;
        state.blockContent = action.payload.content;
        state.blockHtmlContent = action.payload.htmlContent;
        state.blockVideoUrl = action.payload.videoUrl;
        state.blockIsActive = action.payload.isActive;
        state.blockOrder = action.payload.order;
        state.blockDisplayOn = action.payload.displayOn;
        state.blockConfig = action.payload.config;
        state.blockImages = action.payload.images;
      })
      .addCase(getAContentBlock.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAContentBlock.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAContentBlock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedContentBlock = action.payload;
      })
      .addCase(updateAContentBlock.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAContentBlock.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAContentBlock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedContentBlock = action.payload;
      })
      .addCase(deleteAContentBlock.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default cmsContentBlocksSlice.reducer;

